import Image from 'next/image'
import ImageWithTransition from 'components/Elements/ImageWithTransition'

export const TwoColumns = ({ sources }) => {
      return sources.map((src, key) => (
            <div key={key} className='col-span-1'>
                  <div className='image-container'>
                        <ImageWithTransition src={src} layout='fill' alt='' sizes='50vw' />
                  </div>
            </div>
      ))
}

export const OneColumn = ({ source }) => {
      return (
            <div className='col-span-2'>
                  <div className='image-container'>
                        <ImageWithTransition src={source} layout='fill' alt='' />
                  </div>
            </div>
      )
}

export const TwoRows = ({ sources }) => {
      return (
            <>
                  <div className='col-span-1 row-span-2'>
                        <div className='image-container'>
                              <ImageWithTransition src={sources[0]} layout='fill' alt='' />
                        </div>
                  </div>
                  <div className='col-span-1'>
                        <div className='image-container'>
                              <ImageWithTransition sizes='50vw' objectFit='cover' src={sources[1]} layout='fill' alt='' />
                        </div>
                  </div>
                  <div className='col-span-1'>
                        <div className='image-container'>
                              <ImageWithTransition sizes='50vw' objectFit='cover' src={sources[2]} layout='fill' alt='' />
                        </div>
                  </div>
            </>
      )
}
